import {
    validationDefault,
    validationDefaultNew,
    maxModeloVehiculo,
} from '../../components/utilities/rulesUtilities';
import { requestsListStatus } from './RequestsListStatus';
import genericOptions from '../defaultConfigRole/genericOptions';
import genericColumnsCalculator from '../defaultConfigRole/genericColumnsCalculator';
import {
    PROPERTIES,
    URL,
    REPRESENTATIVE_NAMES,
} from '../../constants/constantValues';

const Rules = {
    role_1922665e7b584eb19c224ef09f75a84e: {
        //Aliado
        home: 'credits',
        requestsListStatus,
        views: {
            create: {
                titleRequestCredit: 'Solicitudes de créditos',
                permisions: ['createRequestCredit', 'listRequestCredit'],
                noShowTableInfo: true,
                components: [
                    {
                        name: 'Validación del solicitante',
                        component: ['ValidationClient'],
                    },
                    {
                        name: 'Información del Solicitante',
                        component: ['InformationClient'],
                    },
                    {
                        name: 'Información de la solicitud',
                        component: [
                            'InformationCredit',
                            'CalculatorCreditExternal',
                        ],
                    },
                    {
                        name: 'Información de Contacto',
                        component: ['BusinessInformationCreditAlly'],
                    },
                    // {
                    //     name: 'Verificación SMS',
                    //     component: ['SmsValidationCredit'],
                    // },
                    {
                        name: 'Autorización Digital',
                        component: ['AuthorizationCredit'],
                    },
                ],
                actionStatus: ['desistir'],
                actionStatusAll: ['resumen'],
                groupUser: 25,
                causalType: 1,
            },
            consult: {
                permisions: [],
                components: [],
            },
            profile: {
                fields: [
                    {
                        name: 'email',
                        label: 'Correo electrónico',
                        disabled: false,
                        type: 'email',
                        col: 6,
                        validation: validationDefaultNew(
                            [{ type: 'required', value: true }],
                            'correo electrónico'
                        ),
                    },
                    {
                        name: 'identification_number',
                        label: 'Número de identificación',
                        disabled: false,
                        type: 'integer',
                        col: 6,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.ID_NUMBER.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.ID_NUMBER.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.ID_NUMBER.minLength,
                                },
                            ],
                            'número de identificacion'
                        ),
                    },
                    {
                        name: 'first_name',
                        label: 'Nombres',
                        disabled: false,
                        type: 'string',
                        col: 4,
                        validation: validationDefaultNew(
                            [{ type: 'required', value: true }],
                            'nombres'
                        ),
                    },
                    {
                        name: 'last_name',
                        label: 'Apellidos',
                        disabled: false,
                        type: 'string',
                        col: 4,
                        validation: validationDefaultNew(
                            [{ type: 'required', value: true }],
                            'apellidos'
                        ),
                    },
                    {
                        name: 'phone_number',
                        label: 'Número telefónico',
                        disabled: false,
                        type: 'celular',
                        col: 4,
                        validation: validationDefaultNew(
                            [{ type: 'required', value: true }],
                            'número telefónico'
                        ),
                    },
                ],
            },
        },
        components: {
            informationClient: {
                permisions: [
                    'informationClient:list',
                    'informationClient:edit',
                ],
                automaticFilters: true,
                fields: [
                    {
                        name: 'tipo_identificacion',
                        label: 'Tipo identificación',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: genericOptions.tipo_de_documento,
                        validation: validationDefault(
                            ['required'],
                            'tipo de documento'
                        ),
                        testid: 'ClientTypeIdInput',
                    },
                    {
                        label: 'Número de identificación',
                        name: 'numero_identificacion',
                        disabled: true,
                        type: 'integer',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.ID_NUMBER.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.ID_NUMBER.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.ID_NUMBER.minLength,
                                },
                            ],
                            'numero de identificación'
                        ),
                        testid: 'ClientIdInput',
                    },
                    {
                        name: 'primer_nombre',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.FIRST_NAME.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.FIRST_NAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.FIRST_NAME.minLength,
                                },
                            ],
                            'primer nombre'
                        ),
                        testid: 'ClientFirsNameInput',
                    },
                    {
                        name: 'segundo_nombre',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.SECOND_NAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.SECOND_NAME.minLength,
                                },
                            ],
                            'segundo nombre'
                        ),
                        testid: 'ClientSecondNameInput',
                    },
                    {
                        name: 'primer_apellido',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.FIRST_SURNAME.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.FIRST_SURNAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.FIRST_SURNAME.minLength,
                                },
                            ],
                            'primer apellido'
                        ),
                        testid: 'ClientLastFirsNameInput',
                    },
                    {
                        name: 'segundo_apellido',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.FIRST_SURNAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.FIRST_SURNAME.minLength,
                                },
                            ],
                            'segundo apellido'
                        ),
                        testid: 'ClientSecondFirsNameInput',
                    },
                    {
                        name: 'fecha_nacimiento',
                        disabled: false,
                        type: 'date',
                        col: 3,
                        validation: validationDefault(
                            ['required'],
                            'fecha de nacimiento'
                        ),
                        testid: 'ClientBirthDateInput',
                    },
                    // {
                    //     name: 'grupo_social',
                    //     disabled: false,
                    //     type: 'select',
                    //     col: 3,
                    //     options: genericOptions.grupo_etnico,
                    //     validation: validationDefault(
                    //         ['required'],
                    //         'Grupo social'
                    //     ),
                    // },
                ],
            },
            contactsClient: {
                permisions: ['contactsClient:list', 'contactsClient:edit'],
                tittle: 'solicitante',
                fields: [],
            },
            informationCredit: {
                permisions: [
                    'informationCredit:list',
                    'informationCredit:edit',
                ],
                fields: [
                    {
                        name: 'subproducto',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: [],
                        parentDependency: true,
                        notSearchGlobals: true,
                        url: URL.SUBPRODUCTO_POR_PRODUCTO.value,
                        reduxParams: ['credit.productoInformationCredit'],
                        validation: validationDefault(
                            ['required'],
                            'subproducto'
                        ),
                        testid: 'SubproductInput',
                    },
                    {
                        name: 'origen',
                        disabled: true,
                        type: 'select',
                        col: 3,
                        url: URL.ORIGEN.value,
                        defaultValue: {
                            label: `USUARIO ${REPRESENTATIVE_NAMES.GENERAL_NAME} (ALIADO DIGITAL)`,
                            value: 8,
                        },
                        testid: 'originInput',
                    },
                    {
                        name: 'medio',
                        label: `Medio por el cual se entero de ${REPRESENTATIVE_NAMES.COMERCIAL_NAME}`,
                        disabled: false,
                        type: 'select',
                        col: 6,
                        url: URL.MEDIO.value,
                        defaultValue: {
                            value: 5,
                            label: 'CONCESIONARIO',
                        },
                        validation: validationDefault(['required'], 'medio'),
                        testid: 'mediumInput',
                    },
                ],
                fieldsDynamic: [],
                defaultValues: {
                    oficina: 9,
                    producto: 17,
                    origen: 1,
                    medio: 1,
                    tipo_credito: 1,
                    monto_solicitado: 5000000,
                    plazo_solicitado: 2,
                    cuota_inicial_solicitada: 1500000,
                    asesor: 'asesor test',
                    telefono_asesor: '123456798',
                    concesionario: 'concesionario test',
                    marca: 'Bajaj',
                    linea: 'Pulsar',
                    valor: 8000000,
                    soat: 480000,
                    impuestos: 120000,
                    matricula: 200000,
                    nombre_concesionario: 'concesionario test!',
                    tipo_motocicleta: 'motocicleta',
                },
            },
            productCredit: {
                permisions: ['productCredit:list', 'productCredit:edit'],
                fields: [],
                filedsConditional: {
                    p2: [
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: `/users/{0}/concesionarios/?is_active_concesionario=true`,
                            reduxParams: ['authUser.user'],
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                            testid: 'BrandInput',
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: [],
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'línea'
                            ),
                            testid: 'LineInput',
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo vehículo'
                            ),
                            testid: 'TypeInput',
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                            testid: 'ValueInput',
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                            testid: 'SoatInput',
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                            testid: 'TaxInput',
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matrícula'
                            ),
                            testid: 'RegistrationInput',
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                            testid: 'PaymentInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                            testid: 'ConcessionaireCityInput',
                        },
                    ],
                    p3: [
                        // Prestamiga
                        {
                            name: 'destino_recursos',
                            disabled: false,
                            type: 'string',
                            col: 4,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                ],
                                'destino de los recursos'
                            ),
                            testid: 'DestinoRecursosInput',
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            url: `/users/{0}/concesionarios/`,
                            reduxParams: ['authUser.user'],
                            childrenDependency: 'aliado_concesionario',
                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: false,
                            type: 'price',
                            col: 4,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                            testid: 'ConcessionaireCityInput',
                        },
                    ],
                    p8: [
                        // Prestamiga Preferencial
                        {
                            name: 'destino_recursos',
                            disabled: false,
                            type: 'string',
                            col: 4,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                ],
                                'destino de los recursos'
                            ),
                            testid: 'DestinoRecursosInput',
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            url: `/users/{0}/concesionarios/`,
                            reduxParams: ['authUser.user'],
                            childrenDependency: 'aliado_concesionario',
                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: false,
                            type: 'price',
                            col: 4,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                            testid: 'ConcessionaireCityInput',
                        },
                    ],
                    p10: [
                        // Prestamiga Renovación
                        {
                            name: 'destino_recursos',
                            disabled: false,
                            type: 'string',
                            col: 4,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                ],
                                'destino de los recursos'
                            ),
                            testid: 'DestinoRecursosInput',
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            url: `/users/{0}/concesionarios/`,
                            reduxParams: ['authUser.user'],
                            childrenDependency: 'aliado_concesionario',
                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: false,
                            type: 'price',
                            col: 4,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                            testid: 'ConcessionaireCityInput',
                        },
                    ],
                    p18: [
                        // Prestamiga Reactivación
                        {
                            name: 'destino_recursos',
                            disabled: false,
                            type: 'string',
                            col: 4,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                ],
                                'destino de los recursos'
                            ),
                            testid: 'DestinoRecursosInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: false,
                            type: 'price',
                            col: 4,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                            testid: 'ConcessionaireCityInput',
                        },
                    ],
                    p6: [
                        // Cultiva
                        {
                            name: 'destino_recursos',
                            disabled: false,
                            type: 'string',
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                ],
                                'destino de los recursos'
                            ),
                            testid: 'DestinoRecursosInput',
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: `/users/{0}/concesionarios/?is_active_concesionario=true`,
                            reduxParams: ['authUser.user'],
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                            testid: 'ConcessionaireCityInput',
                        },
                    ],
                    p12: [
                        // Cultiva renovación
                        {
                            name: 'destino_recursos',
                            disabled: false,
                            type: 'string',
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                ],
                                'destino de los recursos'
                            ),
                            testid: 'DestinoRecursosInput',
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: `/users/{0}/concesionarios/?is_active_concesionario=true`,
                            reduxParams: ['authUser.user'],
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                            testid: 'ConcessionaireCityInput',
                        },
                    ],
                    p14: [
                        // Cultiva preferencial
                        {
                            name: 'destino_recursos',
                            disabled: false,
                            type: 'string',
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                ],
                                'destino de los recursos'
                            ),
                            testid: 'DestinoRecursosInput',
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: `/users/{0}/concesionarios/?is_active_concesionario=true`,
                            reduxParams: ['authUser.user'],
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                            testid: 'ConcessionaireCityInput',
                        },
                    ],
                    p17: [
                        // Vehiculos
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: `/users/{0}/concesionarios/?is_active_concesionario=true`,
                            reduxParams: ['authUser.user'],
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                            testid: 'BrandInput',
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: [],
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                            testid: 'LineInput',
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                            testid: 'TypeInput',
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                            testid: 'RiskInsuranceInput',
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                            testid: 'ValueInput',
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                            testid: 'SoatInput',
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                            testid: 'TaxInput',
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                            testid: 'RegistrationInput',
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                            testid: 'PaymentInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                            testid: 'ConcessionaireCityInput',
                        },
                    ],
                    p40: [
                        // Vehiculos usados
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: `/users/{0}/concesionarios/?is_active_concesionario=true`,
                            reduxParams: ['authUser.user'],
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                            testid: 'BrandInput',
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: [],
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                            testid: 'LineInput',
                        },
                        {
                            name: 'modelo_vehiculo',
                            label: 'Modelo vehículo',
                            disabled: false,
                            type: 'integer',
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .minLength,
                                    },
                                    {
                                        type: 'max',
                                        value: maxModeloVehiculo(),
                                    },
                                    {
                                        type: 'min',
                                        value: PROPERTIES.VEHICLE_MODEL.min,
                                    },
                                ],
                                'modelo'
                            ),
                            testid: 'ModeloVehiculoInput',
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                            testid: 'TypeInput',
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                            testid: 'RiskInsuranceInput',
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                            testid: 'ValueInput',
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                            testid: 'SoatInput',
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                            testid: 'TaxInput',
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                            testid: 'RegistrationInput',
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                            testid: 'PaymentInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                            testid: 'ConcessionaireCityInput',
                        },
                        {
                            name: 'valor_fasecolda',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            testid: 'ValorFasecoldaInput',
                        },
                    ],
                    p41: [
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: `/users/{0}/concesionarios/?is_active_concesionario=true`,
                            reduxParams: ['authUser.user'],
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                            testid: 'BrandInput',
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: [],
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'línea'
                            ),
                            testid: 'LineInput',
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo vehículo'
                            ),
                            testid: 'TypeInput',
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                            testid: 'ValueInput',
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                            testid: 'SoatInput',
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                            testid: 'TaxInput',
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matrícula'
                            ),
                            testid: 'RegistrationInput',
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                            testid: 'PaymentInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                            testid: 'ConcessionaireCityInput',
                        },
                    ],
                    p42: [
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: `/users/{0}/concesionarios/?is_active_concesionario=true`,
                            reduxParams: ['authUser.user'],
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                            testid: 'BrandInput',
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: [],
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'línea'
                            ),
                            testid: 'LineInput',
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo vehículo'
                            ),
                            testid: 'TypeInput',
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                            testid: 'ValueInput',
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                            testid: 'SoatInput',
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                            testid: 'TaxInput',
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matrícula'
                            ),
                            testid: 'RegistrationInput',
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                            testid: 'PaymentInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                            testid: 'ConcessionaireCityInput',
                        },
                    ],
                    p43: [
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: `/users/{0}/concesionarios/?is_active_concesionario=true`,
                            reduxParams: ['authUser.user'],
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                            testid: 'BrandInput',
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: [],
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'línea'
                            ),
                            testid: 'LineInput',
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo vehículo'
                            ),
                            testid: 'TypeInput',
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                            testid: 'ValueInput',
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                            testid: 'SoatInput',
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                            testid: 'TaxInput',
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matrícula'
                            ),
                            testid: 'RegistrationInput',
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                            testid: 'PaymentInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                            testid: 'ConcessionaireCityInput',
                        },
                    ],
                    p47: [
                        // Vehiculos renovacion
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: `/users/{0}/concesionarios/?is_active_concesionario=true`,
                            reduxParams: ['authUser.user'],
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                            testid: 'BrandInput',
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                            testid: 'LineInput',
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                            testid: 'TypeInput',
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                            testid: 'RiskInsuranceInput',
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                            testid: 'ValueInput',
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                            testid: 'SoatInput',
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                            testid: 'TaxInput',
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                            testid: 'RegistrationInput',
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                            testid: 'PaymentInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                            testid: 'ConcessionaireCityInput',
                        },
                    ],
                    p113: [
                        // Carga2.0
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: `/users/{0}/concesionarios/?is_active_concesionario=true`,
                            reduxParams: ['authUser.user'],
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                            testid: 'BrandInput',
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: [],
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                            testid: 'LineInput',
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                            testid: 'TypeInput',
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                            testid: 'RiskInsuranceInput',
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                            testid: 'ValueInput',
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                            testid: 'SoatInput',
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                            testid: 'TaxInput',
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                            testid: 'RegistrationInput',
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                            testid: 'PaymentInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                            testid: 'ConcessionaireCityInput',
                        },
                    ],
                    p114: [
                        // CARGA_ESPECIALES
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: `/users/{0}/concesionarios/?is_active_concesionario=true`,
                            reduxParams: ['authUser.user'],
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                            testid: 'BrandInput',
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: [],
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                            testid: 'LineInput',
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                            testid: 'TypeInput',
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                            testid: 'RiskInsuranceInput',
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                            testid: 'ValueInput',
                        },
                        {
                            name: 'valor_maquinaria',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor maquinaria'
                            ),
                            testid: 'ValorMaquinariaInput',
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                            testid: 'SoatInput',
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                            testid: 'TaxInput',
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                            testid: 'RegistrationInput',
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                            testid: 'PaymentInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                            testid: 'ConcessionaireCityInput',
                        },
                    ],
                    p115: [
                        // carga pasajeros
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: `/users/{0}/concesionarios/?is_active_concesionario=true`,
                            reduxParams: ['authUser.user'],
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                            testid: 'BrandInput',
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: [],
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                            testid: 'LineInput',
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                            testid: 'TypeInput',
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                            testid: 'RiskInsuranceInput',
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                            testid: 'ValueInput',
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                            testid: 'SoatInput',
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                            testid: 'TaxInput',
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                            testid: 'RegistrationInput',
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                            testid: 'PaymentInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                            testid: 'ConcessionaireCityInput',
                        },
                    ],
                    p117: [
                        // CARGA_ESPECIALES_2.0
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: `/users/{0}/concesionarios/?is_active_concesionario=true`,
                            reduxParams: ['authUser.user'],
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                            testid: 'BrandInput',
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: [],
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                            testid: 'LineInput',
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                            testid: 'TypeInput',
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                            testid: 'RiskInsuranceInput',
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                            testid: 'ValueInput',
                        },
                        {
                            name: 'valor_maquinaria',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor maquinaria'
                            ),
                            testid: 'ValorMaquinariaInput',
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                            testid: 'SoatInput',
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                            testid: 'TaxInput',
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                            testid: 'RegistrationInput',
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                            testid: 'PaymentInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                            testid: 'ConcessionaireCityInput',
                        },
                    ],
                    p118: [
                        // carga pasajeros
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: `/users/{0}/concesionarios/?is_active_concesionario=true`,
                            reduxParams: ['authUser.user'],
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                            testid: 'BrandInput',
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: [],
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                            testid: 'LineInput',
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                            testid: 'TypeInput',
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                            testid: 'RiskInsuranceInput',
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                            testid: 'ValueInput',
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                            testid: 'SoatInput',
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                            testid: 'TaxInput',
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                            testid: 'RegistrationInput',
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                            testid: 'PaymentInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                            testid: 'ConcessionaireCityInput',
                        },
                    ],
                    p119: [
                        //moto_compromiso_valle
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: `/users/{0}/concesionarios/?is_active_concesionario=true`,
                            reduxParams: ['authUser.user'],
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                            testid: 'BrandInput',
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: [],
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'línea'
                            ),
                            testid: 'LineInput',
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo vehículo'
                            ),
                            testid: 'TypeInput',
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                            testid: 'ValueInput',
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                            testid: 'SoatInput',
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                            testid: 'TaxInput',
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matrícula'
                            ),
                            testid: 'RegistrationInput',
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                            testid: 'PaymentInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                            testid: 'ConcessionaireCityInput',
                        },
                    ],
                    p120: [
                        // Prestamiga_compromiso_valle
                        {
                            name: 'destino_recursos',
                            disabled: false,
                            type: 'string',
                            col: 4,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                ],
                                'destino de los recursos'
                            ),
                            testid: 'DestinoRecursosInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: false,
                            type: 'price',
                            col: 4,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                            testid: 'ConcessionaireCityInput',
                        },
                    ],
                    p131: [
                        // MOTO RECONSTRUYE
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: `/users/{0}/concesionarios/?is_active_concesionario=true`,
                            reduxParams: ['authUser.user'],
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                            testid: 'BrandInput',
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: [],
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'línea'
                            ),
                            testid: 'LineInput',
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo vehículo'
                            ),
                            testid: 'TypeInput',
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                            testid: 'ValueInput',
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                            testid: 'SoatInput',
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                            testid: 'TaxInput',
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matrícula'
                            ),
                            testid: 'RegistrationInput',
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                            testid: 'PaymentInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                            testid: 'ConcessionaireCityInput',
                        },
                    ],
                    p132: [
                        // PROGRESA RECONSTRUYE
                        // Prestamiga
                        {
                            name: 'destino_recursos',
                            disabled: false,
                            type: 'string',
                            col: 4,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                ],
                                'destino de los recursos'
                            ),
                            testid: 'DestinoRecursosInput',
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            url: `/users/{0}/concesionarios/`,
                            reduxParams: ['authUser.user'],
                            childrenDependency: 'aliado_concesionario',
                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: false,
                            type: 'price',
                            col: 4,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                            testid: 'ConcessionaireCityInput',
                        },
                    ],
                    p133: [
                        // CAMPO RECONSTRUYE
                        // Cultiva
                        {
                            name: 'destino_recursos',
                            disabled: false,
                            type: 'string',
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                ],
                                'destino de los recursos'
                            ),
                            testid: 'DestinoRecursosInput',
                        },
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: `/users/{0}/concesionarios/?is_active_concesionario=true`,
                            reduxParams: ['authUser.user'],
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                            testid: 'ConcessionaireCityInput',
                        },
                    ],
                    p134: [
                        // CARGA RECONSTRUYE
                        // Vehiculos
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: `/users/{0}/concesionarios/?is_active_concesionario=true`,
                            reduxParams: ['authUser.user'],
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                            testid: 'BrandInput',
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: [],
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                            testid: 'LineInput',
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                            testid: 'TypeInput',
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                            testid: 'RiskInsuranceInput',
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                            testid: 'ValueInput',
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                            testid: 'SoatInput',
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                            testid: 'TaxInput',
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                            testid: 'RegistrationInput',
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                            testid: 'PaymentInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                            testid: 'ConcessionaireCityInput',
                        },
                    ],
                    p135: [
                        // MOTOCARRO RECONSTRUYE
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: `/users/{0}/concesionarios/?is_active_concesionario=true`,
                            reduxParams: ['authUser.user'],
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                            testid: 'BrandInput',
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: [],
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'línea'
                            ),
                            testid: 'LineInput',
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo vehículo'
                            ),
                            testid: 'TypeInput',
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                            testid: 'ValueInput',
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                            testid: 'SoatInput',
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                            testid: 'TaxInput',
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matrícula'
                            ),
                            testid: 'RegistrationInput',
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                            testid: 'PaymentInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                            testid: 'ConcessionaireCityInput',
                        },
                    ],
                    p136: [
                        // PROGRESA COMPROMISO VALLE RECONSTRUYE
                        // Prestamiga_compromiso_valle
                        {
                            name: 'destino_recursos',
                            disabled: false,
                            type: 'string',
                            col: 4,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                ],
                                'destino de los recursos'
                            ),
                            testid: 'DestinoRecursosInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: false,
                            type: 'price',
                            col: 4,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 4,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                            testid: 'ConcessionaireCityInput',
                        },
                    ],
                    p137: [
                        // CARGA 2.0 RECONSTRUYE
                        // Carga2.0
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: `/users/{0}/concesionarios/?is_active_concesionario=true`,
                            reduxParams: ['authUser.user'],
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                            testid: 'BrandInput',
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: [],
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                            testid: 'LineInput',
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                            testid: 'TypeInput',
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                            testid: 'RiskInsuranceInput',
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                            testid: 'ValueInput',
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                            testid: 'SoatInput',
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                            testid: 'TaxInput',
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                            testid: 'RegistrationInput',
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                            testid: 'PaymentInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                            testid: 'ConcessionaireCityInput',
                        },
                    ],
                    p138: [
                        // CARGA ESPECIALES RECONSTRUYE
                        // CARGA_ESPECIALES
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: `/users/{0}/concesionarios/?is_active_concesionario=true`,
                            reduxParams: ['authUser.user'],
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                            testid: 'BrandInput',
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: [],
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                            testid: 'LineInput',
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                            testid: 'TypeInput',
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                            testid: 'RiskInsuranceInput',
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                            testid: 'ValueInput',
                        },
                        {
                            name: 'valor_maquinaria',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor maquinaria'
                            ),
                            testid: 'ValorMaquinariaInput',
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                            testid: 'SoatInput',
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                            testid: 'TaxInput',
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                            testid: 'RegistrationInput',
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                            testid: 'PaymentInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                            testid: 'ConcessionaireCityInput',
                        },
                    ],
                    p139: [
                        // CARGA PASAJEROS RECONSTRUYE
                        // carga pasajeros
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: `/users/{0}/concesionarios/?is_active_concesionario=true`,
                            reduxParams: ['authUser.user'],
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                            testid: 'BrandInput',
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: [],
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                            testid: 'LineInput',
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo de vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                            testid: 'TypeInput',
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            label: 'Seguro todo riesgo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                            testid: 'RiskInsuranceInput',
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                            testid: 'ValueInput',
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                            testid: 'SoatInput',
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                            testid: 'TaxInput',
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                            testid: 'RegistrationInput',
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                            testid: 'PaymentInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                            testid: 'ConcessionaireCityInput',
                        },
                    ],
                    p130: [
                        // MOTO COMPROMISO VALLE RECONSTRUYE
                        //moto_compromiso_valle
                        {
                            name: 'concesionario',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: `/users/{0}/concesionarios/?is_active_concesionario=true`,
                            reduxParams: ['authUser.user'],
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                            testid: 'ConcessionaireInput',
                        },
                        {
                            name: 'marca',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                            testid: 'BrandInput',
                        },
                        {
                            name: 'linea',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            options: [],
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'línea'
                            ),
                            testid: 'LineInput',
                        },
                        {
                            name: 'tipo_vehiculo',
                            label: 'Tipo vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo vehículo'
                            ),
                            testid: 'TypeInput',
                        },
                        {
                            name: 'valor',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                            testid: 'ValueInput',
                        },
                        {
                            name: 'soat',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                            testid: 'SoatInput',
                        },
                        {
                            name: 'impuestos',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                            testid: 'TaxInput',
                        },
                        {
                            name: 'matricula',
                            label: 'Matrícula',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matrícula'
                            ),
                            testid: 'RegistrationInput',
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            disabled: false,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                            testid: 'PaymentInput',
                        },
                        {
                            name: 'monto_solicitado',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                            testid: 'AmountInput',
                        },
                        {
                            name: 'plazo_solicitado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                            testid: 'ConcessionaireCityInput',
                        },
                    ],
                },
            },
            documentsCredit: {
                permisions: ['documentsCredit:list', 'documentsCredit:edit'],
                accept: 'image/png, image/jpeg, image/jpg, application/pdf',
                fields: [
                    {
                        name: 'solicitud_tipo_documento',
                        label: 'Tipo documento',
                        disabled: false,
                        type: 'select',
                        col: 5,
                        url: '/solicitudes/tipo_documentos/?roles=11',
                        showTable: true,
                        validation: validationDefault(
                            ['required'],
                            'tipo de documento'
                        ),
                        testid: 'DocumentTypeInput',
                    },
                    {
                        name: 'documento',
                        disabled: false,
                        type: 'file',
                        col: 5,
                        validation: validationDefault(
                            ['required'],
                            'documento'
                        ),
                        testid: 'DocumentFileInput',
                    },
                ],
            },
            observationCredit: {
                permisions: [
                    'observationCredit:list',
                    'observationCredit:edit',
                    'observationCredit:view',
                ],
                fields: [
                    {
                        className: 'input-observacion',
                        name: 'observacion',
                        disabled: false,
                        type: 'string',
                        rows: 1,
                        typeColumn: 2,
                        col: 12,
                        showTable: true,
                        staticCol: 12,
                        validation: validationDefault(
                            ['required'],
                            'observación'
                        ),
                    },
                ],
            },
            calculatorCredit: {
                permisions: [
                    'calculatorCredit:list',
                    'calculatorCredit:edit',
                    'calculatorCredit:simulator',
                ],
                summaryCredit: genericColumnsCalculator.summaryCredit,
                monthlyValues: genericColumnsCalculator.monthlyValues,
                defaultValues: {},
                fields: [
                    {
                        name: 'subproducto',
                        disabled: false,
                        type: 'select',
                        col: 6,
                        parentDependency: true,
                        url: URL.SUBPRODUCTO_POR_PRODUCTO.value,
                        reduxParams: ['authUser.IdProductosConConcesionario'],
                        validation: validationDefault(
                            ['required'],
                            'subproducto'
                        ),
                        testid: 'SubproductInput',
                    },
                    {
                        name: 'seguro_voluntario',
                        disabled: true,
                        type: 'select',
                        col: 6,
                        options: genericOptions.seguro_voluntario,
                        defaultValue: {
                            value: '0',
                            label: 'SIN SEGURO',
                        },
                        validation: validationDefault(
                            ['required'],
                            'seguro voluntario'
                        ),
                        testid: 'VoluntaryInsureInput',
                    },
                    {
                        name: 'seguro_protegidos',
                        label: 'Seguro PROTEGI2',
                        disabled: false,
                        type: 'select',
                        col: 6,
                        clear: true,
                        url: URL.SEGURO_FAMILIA.value,
                        dependency: 'subproducto',
                        testid: 'ProtectedInsuranceInput',
                    },
                    // {
                    //     label: 'Seguro SBS',
                    //     name: 'tipo_seguro',
                    //     disabled: false,
                    //     type: 'select',
                    //     col: 4,
                    //     options: genericOptions.tipo_seguro_sbs,
                    //     defaultValue: {
                    //         value: '0',
                    //         label: 'SIN SEGURO',
                    //     },
                    //     validation: validationDefault(
                    //         ['required'],
                    //         'seguro sbs'
                    //     ),
                    // },
                ],
            },
            BusinessInformationCreditAlly: {
                permisions: [
                    'BusinessInformationCreditAlly:list',
                    'BusinessInformationCreditAlly:edit',
                ],
                fieldsContacto: [
                    {
                        name: 'persona_info_contacto.celular',
                        label: 'Celular',
                        disabled: false,
                        type: 'celular',
                        col: 6,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'pattern',
                                    value: PROPERTIES.CELL_PHONE.regExp,
                                    mesagge:
                                        'El número ingresado no es un número válido',
                                },
                                {
                                    type: 'required',
                                    value: PROPERTIES.CELL_PHONE.required,
                                },
                            ],
                            'celular'
                        ),
                        testid: 'ContactCellphoneInput',
                    },
                    {
                        name: 'persona_info_contacto.correo_electronico',
                        label: 'Correo electrónico',
                        disabled: false,
                        type: 'email',
                        col: 6,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'pattern',
                                    value: PROPERTIES.EMAIL.regExp,
                                    mesagge:
                                        'El correo electrónico ingresado no es válido',
                                },
                            ],
                            'correo electrónico'
                        ),
                        testid: 'ContactEmailInput',
                    },
                ],
                fieldsNegocio: [
                    {
                        name: 'solicitud_negocio.descripcion_actividad',
                        testid: 'BusinessDescInput',
                        label: 'Descripción de la actividad del negocio',
                        disabled: false,
                        type: 'string',
                        col: 4,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.DESCRIPTION_ACTIVITY
                                        .required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.DESCRIPTION_ACTIVITY
                                        .maxLength,
                                },
                            ],

                            'descripción de la actividad del negocio'
                        ),
                    },
                    {
                        name: 'solicitud_negocio.ciudad_negocio',
                        label: 'Ciudad del negocio',
                        disabled: false,
                        type: 'autocomplete-dependency',
                        col: 4,
                        showTable: true,
                        options: [],
                        parentDependency: true,
                        childrenDependency: 'solicitud_negocio.barrio_negocio',
                        url: URL.CIUDADES_POR_DEPARTAMENTO.value,
                        reduxParams: ['globals.departamentos_regional'],
                        searchSecondParam: true,
                        validation: validationDefault(
                            ['required'],
                            'ciudad del negocio'
                        ),
                        testid: 'BusinessCityInput',
                    },
                    {
                        name: 'solicitud_negocio.barrio_negocio',
                        label: 'Barrio del negocio',
                        disabled: false,
                        type: 'select',
                        col: 4,
                        showTable: true,
                        dependency: 'solicitud_negocio.ciudad_negocio',
                        trueDependency: 'ciudad',
                        options: [],
                        url: URL.BARRIOS.value,
                        validation: validationDefault(
                            ['required'],
                            'barrio del negocio'
                        ),
                        testid: 'BusinessNeighborhoodInput',
                    },
                    {
                        name: 'solicitud_negocio.direccion',
                        label: 'Dirección del negocio',
                        disabled: false,
                        type: 'addressComplement',
                        staticCol: 12,
                        validation: validationDefault(
                            ['required'],
                            'dirección del negocio'
                        ),
                        testid: 'BusinessAddressInput',
                    },
                ],
                defaultValues: {
                    tipo_negocio: 'venta de papa',
                    antiguedad: 8,
                    antiguedad_local: 5,
                    telefono: '7230000',
                    direccion: 'calle  8norte  13a  45',
                    barrio: 'pruebas',
                    sector_economico: 0,
                    tipo_local: 0,
                    empleados_permanentes: 1,
                    empleados_temporales: 1,
                },
            },
        },
    },
};
export default Rules;
